import React from 'react';

const SvgPencilIcon = (props) => (
  <svg viewBox="0 0 10 10" width="1em" height="1em" {...props} id="PencilIcon">
    <path
      d="M5 .1C2.3.1.1 2.3.1 5S2.3 9.9 5 9.9 9.9 7.7 9.9 5 7.7.1 5 .1zm1.84 4.53L3.75 7.72l-1.43.25c-.2.04-.36-.13-.33-.32l.25-1.43 3.09-3.09c.06-.06.14-.06.2 0l1.31 1.31c.06.05.06.14 0 .19zm1.01-1.01l-.54.54c-.06.06-.14.06-.2 0L5.8 2.86c-.06-.06-.06-.14 0-.2l.54-.54c.22-.22.58-.22.8 0l.71.71c.22.21.22.57 0 .79z"
      fill="currentColor"
    />
    <path
      d="M5.26 3.9L3.45 5.72a.17.17 0 000 .23c.06.06.17.06.23 0l1.81-1.81a.17.17 0 000-.23.16.16 0 00-.23-.01zM3.02 6.38h-.43l-.13.76.37.36.76-.13v-.43h-.57z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPencilIcon;
